import angular, { IFilterService, IQProvider, IQService, IScope, ITimeoutService } from 'angular';
import uiRouter, { StateService } from '@uirouter/angularjs';
import { TODO } from '@b2b/types/core';
import { ApiService } from '@b2b/common/services/api/types';
import { NoticeFactory } from '@b2b/common/factories/notice';

PartnersCreateController.$inject = [
  '$scope',
  '$state',
  '$q',
  '$filter',
  '$uibModal',
  '$timeout',
  'ApiService',
  'ValidateService',
  'HelpersService',
  'NoticeFactory',
  'CategoriesData',
  'GridStateFactory',
];

function PartnersCreateController(
  $scope: IScope & { partnersCreate: TODO; },
  $state: StateService,
  $q: IQService,
  $filter: IFilterService,
  $uibModal: TODO,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  ValidateService: TODO,
  HelpersService: TODO,
  NoticeFactory: NoticeFactory,
  CategoriesData: TODO,
  GridStateFactory: TODO
) {
  const ctrl = {
    pageType: 'Create',
    submitText: 'Create',
    organizationId: '',
    sameAddress: false,
    isSubmitted: false,
    isSubmitting: false,
    isEditEnabled: false,
    secondaryContacts: [] as TODO[],
    removedSecondaryContacts: [] as TODO[],

    model: {
      company: {
        id: false as string | number | boolean,
        name: '',
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: '',
        country: '',
        phoneNumber: '',
        companyUrl: '',
        zipCode: '',
      },
      primaryContact: {
        id: false,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        accountId: false,
        primary: true,
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: '',
        country: '',
        zipCode: '',
      },
      category: {
        id: '',
      },
      requests: [] as TODO[],
      accountCategoryRelation: null as TODO,
    },

    payment: {
      id: false,
      type: 'fullPayment',
      accountId: false as string | number | boolean,
      uniqueVoucherNumbers: false,
      ticketDelivery: 'print',
      balanceDueDays: 0,
      depositDueDays: 0,
      depositMinimumAmount: 0,
      depositMinimumPercent: 0,
    },

    companyAddress: {} as TODO,
    companyAddressOutput: {},
    primaryContactAddress: {
      streetAddress1: '',
      streetAddress2: '',
      city: '',
      state: '',
      country: '',
      zipCode: '',
    },

    gridState: new GridStateFactory(),

    grid: {
      pageSize: 10,
      paginate: true,
      useExternalPagination: true,
      useExternalSorting: true,
      multiselect: false,
      showFooter: false,
      columns: [
        {
          field: 'id',
          displayName: 'ID',
          visible: false,
        },
        {
          field: 'firstName',
          displayName: 'First Name',
        },
        {
          field: 'lastName',
          displayName: 'Last Name',
        },
        {
          field: 'email',
          displayName: 'Email',
        },
        {
          field: 'phoneNumber',
          displayName: 'Phone Number',
        },
        {
          field: 'streetAddress1',
          displayName: 'Address 1',
        },
        {
          field: 'city',
          displayName: 'City',
        },
        {
          field: 'state',
          displayName: 'State',
        },
        {
          field: 'country',
          displayName: 'Country',
        },
        {
          field: 'zipCode',
          displayName: 'Zip Code',
        },
        {
          field: 'remove',
          displayName: '',
          cellTemplate:
            '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row)">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
        },
      ],
    },

    notes: '',

    notice: new NoticeFactory(),

    savedPayment: {} as TODO,
    selectedCategory: {} as TODO,

    categories: [] as TODO[],

    addModal: null as TODO,
    editModal: null as TODO,
    removeModal: null as TODO,
    changeAddressModal: null as TODO,
    editAddressModal: null as TODO,

    init: function () {
      let titleText = 'Create Organization';

      if ($state.params.hasOwnProperty('accountId')) {
        ctrl.pageType = 'Edit';
        ctrl.isEditEnabled = true;
        ctrl.submitText = 'Update';
        titleText = 'Edit Organization';
      }

      $scope.$emit('Application::contentTitleChange', {
        title: titleText,
        buttonLeft: {
          label: 'Cancel',
          action: function () {
            ctrl.cancel();
          },
        },
        buttonRight: {
          label: ctrl.submitText,
          action: function () {
            ctrl.complete();
          },
        },
      });

      if ($state.params.accountId) {
        ctrl.organizationId = $state.params.accountId;
      }

      if (CategoriesData.data && CategoriesData.data.success) {
        ctrl.success.getCategories(CategoriesData);
      } else {
        ctrl.error.getCategories(CategoriesData);
      }

      if (ctrl.isEditEnabled) {
        ctrl.gridState.updateGridState(null, ctrl.grid.pageSize, 'firstName');
      }

      $scope.$on('AddressList::Create', ctrl.onAddressListCreate);
      $scope.$on('AddressList::Edit', ctrl.onAddressListEdit);
      $scope.$on('AddressDetail::Change', ctrl.onAddressDetailChange);
      $scope.$on('AddressDetail::Edit', ctrl.onAddressDetailEdit);

      $scope.$watch('partnersCreate.sameAddress', ctrl.onSameAddressChange);
      $scope.$watchCollection('partnersCreate.companyAddressOutput', ctrl.onCompanyAddressChange);
    },

    getAccount: function (accountId) {
      ApiService.partners.detail(accountId).then(ctrl.success.init, ctrl.error.init);
    },

    getAccountPayment: function (accountId) {
      ApiService.partners.payments
        .account(accountId)
        .then(ctrl.success.getAccountPayment, ctrl.error.getAccountPayment);
    },

    getAccountContacts: function (accountId) {
      ApiService.partners.contacts
        .list(accountId, ctrl.gridState.getGridState())
        .then(ctrl.success.getAccountContacts, ctrl.error.getAccountContacts);
    },

    isValidCategory: function () {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ctrl.selectedCategory && ctrl.selectedCategory.hasOwnProperty('id');
      }

      return r;
    },

    isValidCompany: function (field) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            len: {
              value: ctrl.model.company[field],
            },
          },
        ]);
      }

      return r;
    },

    isValidContact: function (field) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            len: {
              value: ctrl.model.primaryContact[field],
            },
          },
          {
            name: ctrl.model.primaryContact[field],
          },
        ]);
      }

      return r;
    },

    isValidPhone: function (prop) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([
          {
            phone: prop,
          },
        ]);
      }

      return r;
    },

    isValidEmail: function (email) {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ValidateService.validate([{ email: email }]);
      }

      return r;
    },

    filterContacts: function (contacts: TODO, primary: boolean) {
      const filtered: TODO[] = [];
      for (let i = 0, ii = contacts.length; i < ii; i++) {
        if (contacts[i].primary === primary) {
          filtered.push(contacts[i]);
        }
      }
      return filtered;
    },

    findContact: function (contacts: TODO[], id: string | number) {
      const r = { index: -1, contact: null as TODO };
      for (let i = 0, ii = contacts.length; i < ii; i++) {
        if (contacts[i].id === id) {
          r.contact = contacts[i];
          r.index = i;
          break;
        }
      }
      return r;
    },

    addSecondaryContact: function () {
      ctrl.addModal = $uibModal.open({
        templateUrl: 'views/application/views/partners/create/modals/ManageSecondaryContactModal.tpl.html',
        size: 'lg',
        controller: 'ManageSecondaryContactModalController',
        resolve: {
          ValidateService: function () {
            return ValidateService;
          },
          alertMessage: function () {
            return null;
          },
          organizationId: function () {
            return $state.params.accountId;
          },
          organizationName: function () {
            return $state.params.accountName;
          },
          contact: function () {
            return null;
          },
          address: function () {
            return null;
          },
        },
      });

      ctrl.addModal.result.then(
        function (contact: TODO) {
          //add the secondaryContact
          if (contact) {
            //add the index property to manage this contact locally (not stored on server yet)
            contact.index = ctrl.secondaryContacts.length;
          }
          ctrl.secondaryContacts.push(contact);
        },
        function () {
          //do nothing
        }
      );
    },

    removeSecondaryContact: function (row) {
      let index = -1;
      //first see if this is an existing contact.
      if (row.entity.id) {
        index = ctrl.findContact(ctrl.secondaryContacts, row.entity.id).index;
      } else if (row.entity.index !== undefined) {
        index = row.entity.index;
      }
      if (index > -1) {
        ctrl.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/create/modals/RemoveSecondaryContactModal.tpl.html',
          size: 'lg',
          controller: 'RemoveSecondaryContactModalController',
          resolve: {
            ValidateService: function () {
              return ValidateService;
            },
            contact: function () {
              return ctrl.secondaryContacts[index];
            },
          },
        });

        ctrl.removeModal.result.then(
          function () {
            //remove the secondaryContact
            if (row.entity.id) {
              //remove later when page is saved
              ctrl.removedSecondaryContacts.push(ctrl.secondaryContacts.splice(index, 1)[0]);
            } else {
              ctrl.secondaryContacts.splice(index, 1);
            }
          },
          function () {
            //do nothing
          }
        );
      }
    },

    editSecondaryContact: function (item) {
      let index = -1;
      if (item.id) {
        index = ctrl.findContact(ctrl.secondaryContacts, item.id).index;
      } else if (item.index !== undefined) {
        index = item.index;
      }
      if (index > -1) {
        ctrl.editModal = $uibModal.open({
          templateUrl: 'views/application/views/partners/create/modals/ManageSecondaryContactModal.tpl.html',
          size: 'lg',
          controller: 'ManageSecondaryContactModalController',
          resolve: {
            ValidateService: function () {
              return ValidateService;
            },
            alertMessage: function () {
              return null;
            },
            organizationId: function () {
              return $state.params.accountId;
            },
            organizationName: function () {
              return $state.params.accountName;
            },
            contact: function () {
              return ctrl.secondaryContacts[index];
            },
            address: function () {
              return null;
            },
          },
        });

        ctrl.editModal.result.then(
          function (contact) {
            //update the secondaryContact
            if (contact) {
              ctrl.secondaryContacts[index] = contact;
            }
          },
          function () {
            //do nothing
          }
        );
      }
    },

    changeAddress: function (type, contactId, address) {
      ctrl.changeAddressModal = $uibModal.open({
        templateUrl: 'views/application/views/partners/create/modals/SelectAddressModal.tpl.html',
        size: 'lg',
        controller: 'SelectAddressModalController',
        resolve: {
          organizationId: function () {
            return $state.params.accountId;
          },
          contactId: function () {
            return contactId;
          },
          address: function () {
            return address;
          },
        },
      });

      ctrl.changeAddressModal.result.then(
        function (address) {
          $scope.$broadcast('AddressDetail::Update', { type: type, contactId: contactId, address: address });
        },
        function () {
          //do nothing
        }
      );
    },

    createEditAddress: function (address?: TODO) {
      ctrl.editAddressModal = $uibModal.open({
        templateUrl: 'views/application/views/partners/create/modals/CreateEditAddressModal.tpl.html',
        size: 'md',
        controller: 'CreateEditAddressModalController',
        resolve: {
          organizationId: function () {
            return $state.params.accountId;
          },
          address: function () {
            return address || {};
          },
          preventSave: function () {
            return true;
          },
        },
      });

      ctrl.editAddressModal.result.then(
        function (address) {
          $scope.$broadcast('AddressDetail::Update', { address: address });
          $scope.$broadcast('AddressList::Refresh');
        },
        function () {
          //do nothing
          $scope.$broadcast('AddressList::Refresh');
        }
      );
    },

    createPayment: function (accountId) {
      if (accountId) {
        ctrl.savedPayment.accountId = accountId;
        ApiService.partners.payments
          .create(ctrl.savedPayment)
          .then(ctrl.success.createPayment, ctrl.error.createPayment);
      } else {
        ctrl.notice.showErrorMessages([{ message: 'There was a problem updating the payment policy.' }]);
      }
    },

    savePayment: function (payment) {
      ctrl.savedPayment = payment;
    },

    create: function () {
      const tests = [
        { phone: ctrl.model.company.phoneNumber },
        { len: { value: ctrl.model.company.name } },
        { len: { value: ctrl.model.company.streetAddress1 } },
        { len: { value: ctrl.model.company.city } },
        { len: { value: ctrl.model.company.country } },
        { email: ctrl.model.primaryContact.email },
        { phone: ctrl.model.primaryContact.phoneNumber },
        { name: ctrl.model.primaryContact.firstName },
        { name: ctrl.model.primaryContact.lastName },
      ];

      if (
        ctrl.model.company.country &&
        (ctrl.model.company.country === 'Canada' || ctrl.model.company.country === 'United States')
      ) {
        tests.push({ len: { value: ctrl.model.company.state } });
      }

      ctrl.isSubmitted = true;

      if (ctrl.isValidCategory()) {
        // Copy category id into model before saving
        ctrl.model.category.id = ctrl.selectedCategory.id;

        if (ValidateService.validate(tests)) {
          ApiService.partners.create(ctrl.model).then(ctrl.success.create, ctrl.error.create);
        } else {
          ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
        }
      } else {
        ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
      }
    },

    updatePrimaryContact: function (organizationId, contact) {
      // Create the address before assigning it
      ApiService.organizations.addresses
        .create({
          isPrimary: false,
          organizationId: organizationId,
          address: ctrl.primaryContactAddress,
        })
        .then(function (response) {
          const props = response.data.payload;

          // Swap Id's for this endpoint
          props.addressId = props.id;
          props.id = contact.id;
          // Update the contact with newly created address
          ApiService.organizations.contacts
            .update(
              $.extend(
                {
                  organizationId: organizationId,
                  isPrimary: true,
                },
                props
              )
            )
            .then(ctrl.success.updatePrimaryContact, ctrl.error.updatePrimaryContact);
        }, ctrl.error.updatePrimaryContact);
    },

    complete: function () {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      ctrl.isSubmitting = true;
      ctrl.isSubmitted = false;
      // Make sure payment data gets copied before ajax request is sent to create account
      $scope.$broadcast('PaymentOptions::save');
      $scope.$broadcast('AddressCreate::Check');
      // next tick
      $timeout(function () {
        ctrl.prepareAddresses();
        ctrl.create();
      });
    },

    prepareAddresses: function () {
      ctrl.model.company.streetAddress1 = ctrl.companyAddress.streetAddress1;
      ctrl.model.company.streetAddress2 = ctrl.companyAddress.streetAddress2;
      ctrl.model.company.city = ctrl.companyAddress.city;
      ctrl.model.company.zipCode = ctrl.companyAddress.zipCode;

      ctrl.model.company.state = ctrl.companyAddress.state;
      ctrl.model.company.country = ctrl.companyAddress.country;

      // Primary contact data
      if (!ctrl.sameAddress) {
        ctrl.model.primaryContact.streetAddress1 = ctrl.primaryContactAddress.streetAddress1;
        ctrl.model.primaryContact.streetAddress2 = ctrl.primaryContactAddress.streetAddress2;
        ctrl.model.primaryContact.city = ctrl.primaryContactAddress.city;
        ctrl.model.primaryContact.zipCode = ctrl.primaryContactAddress.zipCode;
        ctrl.model.primaryContact.state = ctrl.primaryContactAddress.state;
        ctrl.model.primaryContact.country = ctrl.primaryContactAddress.country;
      }
    },

    cancel: function () {
      $state.go('application.partners.list.default');
    },

    findAccountCategory: function (name) {
      let r: { index: number; category: TODO } | false = false;

      for (let i = 0, ii = ctrl.categories.length; i < ii; i++) {
        if (name === ctrl.categories[i].name) {
          r = {
            index: i,
            category: ctrl.categories[i],
          };
          break;
        }
      }

      return r;
    },

    unmarshalPayment: function (paymentObj) {
      const deposit = paymentObj.desposit || { daysBeforeEvent: 0, minAmount: 0, percent: 0 };
      const payment = {
        id: paymentObj.id,
        type: paymentObj.type,
        accountId: paymentObj.accountId,
        uniqueVoucherNumbers: paymentObj.uniqueVoucherNumbers,
        ticketDelivery: paymentObj.ticketDelivery,
        balanceDueDays: paymentObj.balanceDue ? paymentObj.balanceDue.days : 0,
        depositDueDays: deposit.daysBeforeEvent || 0,
        depositMinimumAmount: deposit.minAmount || 0,
        depositMinimumPercent: deposit.percent || 0,
      };
      return payment;
    },

    success: {
      init: function (response) {
        ctrl.model = response.data.payload;
        ctrl.payment.accountId = ctrl.model.company.id;
        ctrl.notes = ctrl.model.requests[0] ? ctrl.model.requests[0].posNotes : '';
        if (ctrl.model.accountCategoryRelation) {
          const foundCategory = ctrl.findAccountCategory(ctrl.model.accountCategoryRelation.categoryName);
          ctrl.selectedCategory = foundCategory ? foundCategory.category : null;
        }
      },

      getAccountPayment: function (response) {
        ctrl.payment = ctrl.unmarshalPayment(response.data.payload);
      },

      getAccountContacts: function (response) {
        ctrl.secondaryContacts = ctrl.filterContacts(response.data.payload.list, false);
        ctrl.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
        //TODO: filter out primary contact?
      },

      create: function (response) {
        // When account has been created apply the payment policy to the account
        // Since we copied the result of the payment directive before the request was sent
        // It should be ready for us.
        // Apply the payment policy to the new partner account
        Object.assign(ctrl.model.company, response.data.payload.company);
        // Update the primary contact with latest info
        ctrl.model.primaryContact = response.data.payload.primaryContact;
        ctrl.isEditEnabled = true;
        ctrl.createPayment(response.data.payload.company.id);
      },

      createPayment: function (response) {

        // create secondary contacts for this account
        // Don't update the address if same address as company
        if (!ctrl.sameAddress) {
          ctrl.updatePrimaryContact(ctrl.model.company.id, ctrl.model.primaryContact);
        } else {
          ApiService.organizations.contacts
            .update(
              Object.assign({}, ctrl.model.company, ctrl.model.primaryContact, {
                organizationId: ctrl.model.company.id,
                isPrimary: true,
                primary: true,
              })
            )
            .then(ctrl.success.updatePrimaryContact, ctrl.error.updatePrimaryContact);
        }
      },

      updatePrimaryContact: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        $state.go('application.partners.detail', { id: ctrl.model.company.id });
      },

      getCategories: function (response) {
        ctrl.categories = response.data.payload.list;
      },
    },

    error: {
      init: function (response) {
        // noop
      },

      create: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.showErrorMessages([
          {
            message: response.data.error,
          },
        ]);
      },

      updatePrimaryContact: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.showErrorMessages([
          {
            message: response.data.error,
          },
        ]);
      },

      createPayment: function (response) {
        ctrl.isSubmitted = true;
        ctrl.isSubmitting = false;
        ctrl.notice.hideSuccessMessages();
        ctrl.notice.showErrorMessages([
          {
            message: response.data.error,
          },
        ]);
      },

      getCategories: function (response) {
        // noop
      },
      getAccountPayment: function (response) {
        // noop
      },
      getAccountContacts: function (response) {
        // noop
      },
    },

    broadcastCompanyAddress: function () {
      $scope.$broadcast('AddressCreate::Set', {
        id: 'partners-create-primary-contact-address',
        model: ctrl.companyAddressOutput,
      });
    },

    onSameAddressChange: function (newVal, prevVal) {
      if (newVal && !prevVal) {
        ctrl.broadcastCompanyAddress();
      } else if (!newVal && prevVal) {
        $scope.$broadcast('AddressCreate::Reset', { id: 'partners-create-primary-contact-address' });
      }
    },

    onCompanyAddressChange: function () {
      if (ctrl.sameAddress) {
        ctrl.broadcastCompanyAddress();
      }
    },

    // When payment has process from directive continue with completion
    onPaymentUpdate: function (payment) {
      ctrl.savePayment(payment);
    },

    onAddressDetailChange: function (e, data) {
      ctrl.changeAddress(data.type, data.contactId, data.address);
    },

    onAddressDetailEdit: function (e, data) {
      ctrl.createEditAddress(data.address);
    },

    onAddressListCreate: function (e, data) {
      ctrl.createEditAddress();
    },

    onAddressListEdit: function (e, data) {
      ctrl.createEditAddress(data.address);
    },
  };

  $scope.partnersCreate = ctrl;

  ctrl.init();
}

export const PartnersCreateModule = angular
  .module('acme.view.application.partners.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.validate',
    'acme.common.service.helpers',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
  ])

  .controller('PartnersCreateController', PartnersCreateController).name;
